import React, {Component} from 'react';
import styles from '../../index.css';
import localStyles from './index.css';
import FontAwesome from 'react-fontawesome';
import {Noria, Bubbles, Popup} from '../index';
import {observer} from 'mobx-react';
import settings from '../../../../stores/cultureSettings.json'

@observer
export default class Bunker extends Component {
    state = {active:false};
    coords(e){
        let target = e.target;
        let X = target.getBoundingClientRect().right + 5;
        let Y = target.getBoundingClientRect().top - 10;
        this.setState({active:true,x:X,y:Y})
    }
    
    render() {
        let i = this.props.inPath ? 0 : this.props.i;
        let item = this.props.item;
        let levelHeight = {height: (item.type === 'output' ? 50 : (item.amount/ (item.totalCapacity * Math.pow(settings[item.culture].volume,2))) * 100) + '%'};
        const index={zIndex:item.active ? (1000 - i) : null};
        return (
            <div className={localStyles.bunker + ' '
                  + styles[item.culture] + ' '
                  + localStyles[item.status]
                  + (this.props.inPath ? ' ' + localStyles.inPath : '')}
                  onMouseOver={this.coords.bind(this)} onMouseLeave={()=>this.setState({active:false})}>
                <div className={styles.bunkerFakeContainer}>
                    <div className={styles.bunkerLevel} style={levelHeight}/>
                </div>
                <div className={localStyles.bunkerType + (this.props.inPath ? ' ' + localStyles.hide : '')}><FontAwesome
                    name={item.bunkerType ? item.bunkerType : ''}/></div>
                {item.type === 'output' ?
                    null
                    :
                    <div className={localStyles.bunkerNumbers}>
                        <span>{Math.ceil(item.amount)}</span>
                        <hr/>
                        <span>{Math.ceil(item.totalCapacity * settings[item.culture].volume)}</span>
                    </div>
                }
                <div className={styles.bunkerLines + (this.props.inPath ? ' ' + localStyles.hide : '')} style={index}>
                    <Noria culture={item.active ? item.culture : 'None'} noriaStatus={item.status}/>
                </div>
                <div className={localStyles.bunkerInputLine + (this.props.inPath ? ' ' + localStyles.hide : '') + (item.status === 'clogged' ? ' ' + localStyles['clogged'] : item.active ? ' ' + localStyles[item.culture] : '')}
                    style={{zIndex:item.type === 'output'  || !item.active ? '': (1000-i)}}
                />
                <div className={styles.bunkerBubbles + (this.props.inPath ? ' ' + localStyles.hide : '')}>
                    <Bubbles culture={item.activeTransport.disabled ? "None" : item.culture}/>
                </div>
                {this.state.active ?
                    <Popup x={this.state.x} y={this.state.y} item={item}/> : null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Bunker/index.js